import { takeEvery } from 'redux-saga/effects';

import { update } from 'store/modules/listing/customPrices';

import * as customPrices from './utils';

export default function* listenUpdate() {
  yield takeEvery(update.toString(), customPrices.update);
}
